const inActivateMenu = () => {
    $('body').removeClass('is-nav-mobile-active');
};

const BackDrop = () => {
    return (
        <div
            className='nav-main-backdrop'
            onClick={inActivateMenu}
        ></div>
    );
};

export default BackDrop;
